import cx from 'classnames';
import { PRICE_IS_DISPLAYED_FOR, PRICE_WAS_DISPLAYED_FOR } from 'mk/autogenerated/translations/ProductPriceHistory.b5579f5e44cfc774f915aa0ce4690a21'
import { formatPrice } from 'mk/bazaar/common/formatters';
import { ProductPrice } from 'mk2/apps/bazaar/schemas';
import { timeAt, timeBetween } from 'mk2/helpers/timeformat';
import React from 'react';
import styles from './ProductPriceHistory.mscss';

interface OwnProps {
    className?: string;
    prices: ProductPrice[];
}

type Props = OwnProps;

const ProductPriceHistory = React.memo<Props>(({ className, prices }) => {
    return (
        <table className={cx(styles.ProductPriceHistory, className)}>
            {prices.map((history) => (
                <tr key={'history-' + new Date(history.startTime).getTime()}>
                    <td className={cx(styles.ProductPriceHistory__cell, styles.ProductPriceHistory__date)}>
                        {timeAt(history.startTime)}
                    </td>
                    <td className={cx(styles.ProductPriceHistory__cell, styles.ProductPriceHistory__price)}>
                        {formatPrice(history.price)}
                    </td>
                    <td className={cx(styles.ProductPriceHistory__cell, styles.ProductPriceHistory__age)}>
                        ({!history.endTime ? PRICE_IS_DISPLAYED_FOR : PRICE_WAS_DISPLAYED_FOR}{' '}
                        {timeBetween(history.startTime, history.endTime)})
                    </td>
                </tr>
            ))}
        </table>
    );
});

ProductPriceHistory.displayName = 'ProductPriceHistory';

export default ProductPriceHistory;
